window?.addEventListener('DOMContentLoaded', function () {
  const faqSections = document?.querySelectorAll('.faq-section');
  faqSections?.forEach((item) => {
    const tabs = item?.querySelectorAll('.faq-tabs button');
    const faqs = item?.querySelectorAll('.faqs-content');
    tabs?.forEach((btn) => {
      btn?.addEventListener('click', function () {
        const btnData = btn?.dataset?.tab;
        tabs?.forEach((i) => i?.classList?.remove('active'));
        faqs?.forEach((i) => i?.classList?.remove('active'));
        btn?.classList?.add('active');

        if (btnData) {
          const activeFaq = item?.querySelectorAll(
            `.faqs-content[data-tab="${btnData}"]`,
          );
          if (activeFaq?.length > 0) {
            activeFaq?.forEach((i) => i?.classList?.add('active'));
          }
        }
      });
    });
  });
});
